<template>
  <Card class="contact-card" v-bind="$attrs" :class="['contact-card--' + theme]">
    <template #header>
      <Avatar :value="value.avatar" :size="avatarSize" />
    </template>
    <template #default>
      <div class="contact-card__title">
        <slot name="title">
          <span>{{ value.name }}</span>
          <Badge v-if="value.company" :value="value.company.name" />
          <Badge v-if="value.demo" theme="warning">{{ $t('demo') }}</Badge>
        </slot>
      </div>
      <div class="contact-card__subtitle">
        <slot name="subtitle">
          <a v-if="value.email" :href="`mailto:${value.email}`" target="_blank">{{ value.email }}</a>
          <a v-if="value.phone" :href="`tel:${value.phone}`">{{ value.phone }}</a>
        </slot>
      </div>
      <div v-if="theme === 'card' && $path('tags.length', value)" class="contact-card__tags">
        <Badge v-for="(item, index) in value.tags" :key="item + index" :value="item" />
      </div>
      <slot name="actions">
        <ButtonComponent
          v-if="theme === 'card'"
          tag="router-link"
          :to="{ name: 'contact-edit', params: { id: value.id } }"
          :label="$t('edit')"
          class="contact-card__action mt-2"
          :icon="['fal', 'pen']"
        />
      </slot>
    </template>
  </Card>
</template>

<script>
import Badge from '@/components/Badge'
import Card from '@/components/Card'
import Avatar from '@/components/Avatar'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    theme: {
      type: String,
      enum: ['card', 'list'],
      default: 'card',
    },
    title: [String, Boolean],
    titleField: {
      type: String,
      default: 'name',
    },
    subtitle: [String, Boolean],
    subtitleField: {
      type: String,
      default: 'email',
    },
  },
  computed: {
    avatarSize() {
      switch (this.theme) {
        case 'list':
          return 'medium'
        default:
          return 'large'
      }
    },
  },
  components: {
    Card,
    Badge,
    Avatar,
  },
}
</script>

<style lang="scss">
.contact-card {
  text-align: center;
  line-height: 1;

  &--card {
    .card__content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .contact-card__title {
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  &--list {
    text-align: left;
    flex-direction: row !important;
    align-items: center;

    box-shadow: none !important;
    background-color: transparent !important;

    .card__header,
    .card__content {
      padding: 0;
    }

    .card__header {
      flex-grow: 0;
      padding-right: 0.75rem;
    }
  }

  .card__header {
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: none;
    padding-bottom: 0;
    min-height: initial;
  }

  .card__content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    text-decoration: none;
  }

  &__title {
    color: var(--dark);
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  &__subtitle {
    color: css-lighten('dark', 30%);
    display: flex;
    font-size: 0.9em;

    a {
      color: inherit;
      text-decoration: none;

      & + a:before {
        content: '·';
        padding-inline: 0.2em;
        opacity: 0.5;
      }
    }
  }
}
</style>
